import AlertProcess from './AlertProcess';
export default class ProcessTree {
  constructor(processes) {
    this.processes = processes;

    this.toString = this.toString.bind(this);
    this.toDTO = this.toDTO.bind(this);
    this.deepCopy = this.deepCopy.bind(this);
  }

  static parse(typeObj) {
    let processes = typeObj['Processes'];
    let processArr = [];
    if (processes != null && processes.length > 0) {
      for (let i = 0; i < processes.length; i++) {
        let current = AlertProcess.parse(processes[i]);
        processArr.push(current);
      }
    }

    return new ProcessTree(processArr);
  }

  deepCopy() {
    let processArr = [];
    if (this.processes != null && this.processes.length > 0) {
      for (let i = 0; i < this.processes.length; i++) {
        let current = AlertProcess.parse(this.processes[i]);
        processArr.push(current);
      }
    }

    return new ProcessTree(processArr);
  }

  toDTO() {}

  toString() {
    return `{ ${this.processes.toString()}}`;
  }
}
